import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { toggleHelpDocument } from 'store/actions/ui.action'

function useInfo() {
    const dispatch = useDispatch()
    const toggleHelpDoc = useCallback(() => dispatch(toggleHelpDocument()), [
        dispatch,
    ])

    return {
        toggleHelpDoc,
    }
}
export default useInfo
